import DebouncedColorField from './DebouncedColorField';
import { CORNER_DOT_TYPES, CORNER_SQUARE_TYPES, DOTS_TYPES } from '../../../utils/qrDesign';

const labelClass = 'mb-1.5 block text-sm font-medium text-slate-700';

function OptionGrid({ options, value, onChange }) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => (
        <button
          key={opt.id}
          type="button"
          onClick={() => onChange(opt.id)}
          className={`rounded-lg px-3 py-2 text-xs font-medium transition ${
            value === opt.id
              ? 'bg-indigo-600 text-white shadow-sm'
              : 'bg-white text-slate-600 ring-1 ring-slate-200 hover:bg-slate-50'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default function ShapeTab({ style, updateStyle }) {
  return (
    <div className="space-y-6">
      <div>
        <p className={labelClass}>Dot style</p>
        <OptionGrid
          options={DOTS_TYPES}
          value={style.dotsType}
          onChange={(v) => updateStyle('dotsType', v)}
        />
      </div>
      <div>
        <p className={labelClass}>Corner squares</p>
        <OptionGrid
          options={CORNER_SQUARE_TYPES}
          value={style.cornersSquareType}
          onChange={(v) => updateStyle('cornersSquareType', v)}
        />
      </div>
      <div>
        <p className={labelClass}>Corner dots</p>
        <OptionGrid
          options={CORNER_DOT_TYPES}
          value={style.cornersDotType}
          onChange={(v) => updateStyle('cornersDotType', v)}
        />
      </div>
      <div className="grid gap-6 sm:grid-cols-2">
        <DebouncedColorField
          id="fg-color"
          label="QR color"
          value={style.fgColor}
          onChange={(v) => updateStyle('fgColor', v)}
        />
        <DebouncedColorField
          id="bg-color"
          label="Background"
          value={style.bgColor}
          onChange={(v) => updateStyle('bgColor', v)}
        />
      </div>
      <div className="grid gap-6 sm:grid-cols-2">
        <div>
          <label htmlFor="qr-size" className={labelClass}>
            Size: {style.size}px
          </label>
          <input
            id="qr-size"
            type="range"
            min={128}
            max={1024}
            step={8}
            value={style.size}
            onChange={(e) => updateStyle('size', Number(e.target.value))}
            className="h-2 w-full cursor-pointer accent-indigo-600"
          />
        </div>
        <div>
          <label htmlFor="qr-margin" className={labelClass}>
            Margin: {style.margin} modules
          </label>
          <input
            id="qr-margin"
            type="range"
            min={0}
            max={8}
            step={1}
            value={style.margin}
            onChange={(e) => updateStyle('margin', Number(e.target.value))}
            className="h-2 w-full cursor-pointer accent-indigo-600"
          />
        </div>
      </div>
    </div>
  );
}

